import { useEffect } from 'react';
import type { SeoData } from '@/seo/resolve';

export function useJsonLd(data: SeoData | null): void {
  useEffect(() => {
    document.head.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());

    if (!data?.jsonLd) return;

    const items = Array.isArray(data.jsonLd) ? data.jsonLd : [data.jsonLd];
    items.forEach((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.textContent = JSON.stringify(item);
      document.head.appendChild(script);
    });
  }, [data]);
}